import { render, staticRenderFns } from "./DiseasesView.vue?vue&type=template&id=1a12e9d8&scoped=true"
import script from "./DiseasesView.vue?vue&type=script&lang=js"
export * from "./DiseasesView.vue?vue&type=script&lang=js"
import style0 from "./DiseasesView.vue?vue&type=style&index=0&id=1a12e9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12e9d8",
  null
  
)

export default component.exports